import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import VModal from 'vue-js-modal';
import VeeValidate from 'vee-validate';
import CKEditor from '@ckeditor/ckeditor5-vue';

import {
  library,
} from '@fortawesome/fontawesome-svg-core';
import {
  FontAwesomeIcon,
} from '@fortawesome/vue-fontawesome';
import {
  faAlignJustify,
  faThLarge,
  faSearch,
  faStream,
} from '@fortawesome/free-solid-svg-icons';

import Notification from './components/notifications/index.vue';

import '@/filters/filter';

library.add(faAlignJustify, faThLarge, faSearch, faStream);

Vue.config.productionTip = false;

Vue.use(VeeValidate, {
  aria: true,
});
Vue.use(VModal, {
  dynamic: true,
  dialog: true,
  clickToClose: true,
});

Vue.use(CKEditor);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('notification', Notification);

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');
